import { Box, Menu, MenuItem, styled, Typography } from '@mui/material';
import React, { useState } from 'react';
import { AppAvatar } from 'components/Avatar';
import styles from './GroupPage.module.scss';
import { Button } from 'tt-ui-lib/core';
import AddIcon from '@mui/icons-material/Add';
import { AboutTab } from './AboutTab';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TabSelect from 'components/Tabs';
import InviteGroupModal from './InviteGroupModal';
import { BlogTab } from './BlogTab';
import { MembersTab } from './MembersTab';
import { EventsTab } from './EventsTab';
import { GROUP } from './fakeGroup';

const TABS = [
  {
    name: 'About',
    child: [],
  },
  {
    name: 'Blog',
    child: [
      {
        name: 'All',
      },
      {
        name: 'Posts',
      },
      {
        name: 'Videos',
      },
      {
        name: 'Articles',
      },
      {
        name: 'News',
      },
      {
        name: 'Podcasts',
      },
      {
        name: 'Activity',
      },
    ],
  },

  {
    name: 'Members',
    child: [
      {
        name: 'Admins',
      },
      {
        name: 'All Members',
      },
    ],
  },
  {
    name: 'Events',
    child: [
      {
        name: 'All events',
      },
      {
        name: 'Upcoming events',
      },
      {
        name: 'Past events',
      },
    ],
  },
];

const GroupPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [inviteModal, setInviteModal] = useState(false);
  const [activeChildTab, setActiveChildTab] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const StyledMenu = styled((props) => (
    <Menu
      id="event-info-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'menu-button',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      boxShadow: '0px 4px 32px 0px rgba(0, 0, 0, 0.08) !important',
      borderRadius: '12px',
      '& .MuiMenu-list': {},
    },
    '& .MuiButtonBase-root': {
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '24px',
    },
  }));

  const renderMembersCount = (count) => {
    if (count >= 1000) {
      let newCount = count / 1000;
      newCount = Math.floor(newCount * 10) / 10;
      return <Box className={styles.countMembers}>{`${newCount} K`}</Box>;
    }
    return <Box className={styles.countMembers}>{count}</Box>;
  };

  const handleChangeActiveTab = (event, value) => {
    setActiveChildTab(0);
    setActiveTab(value);
  };

  const handleChangeSelectChildActiveTab = (value) => {
    setActiveChildTab(value);
  };

  const handleChangeActiveChildTab = (event, value) => {
    setActiveChildTab(value);
  };
  return (
    <Box className={styles.content}>
      <Box className={styles.infoBlock}>
        <Button type="icon" className={styles.menuDotsIcon} onClick={handleClick}>
          <MoreVertIcon width={4} height={14} />
        </Button>
        <StyledMenu>
          <MenuItem>
            <Box>Manage notifications</Box>
          </MenuItem>
          <MenuItem>
            <Box>Pin group</Box>
          </MenuItem>
          <MenuItem>
            <Box>Share</Box>
          </MenuItem>
          <MenuItem>
            <Box className={styles.reportBtn}>Report</Box>
          </MenuItem>
        </StyledMenu>
        <Box className={styles.mainInfo}>
          <AppAvatar userName={`${GROUP.name}`} src={GROUP.image} nav={0} size="mdl" />
          <Box className={styles.groupInfo}>
            <Box className={styles.groupName}>
              {GROUP.name}
              <img src="/images/ph_globe-light.svg" alt="" style={{ width: 24, height: 24 }} />
            </Box>
            <Box className={styles.type}>{GROUP.type}</Box>
            {renderMembersCount(GROUP.members_qty)}
          </Box>
        </Box>
        <Box className={styles.buttons}>
          <Button type="default" className={styles.inviteBtn} onClick={() => setInviteModal(true)}>
            <AddIcon />
            <Typography className={styles.inviteText}>
              Invite{' '}
              <Box component="span" className={styles.inviteTextMobile}>
                to group
              </Box>
            </Typography>
          </Button>
          <Button type="primary">Managed</Button>
        </Box>
      </Box>
      <TabSelect
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        setActiveChildTab={setActiveChildTab}
        activeChildTab={activeChildTab}
        options={TABS}
      />
      {activeTab === 0 ? (
        <AboutTab group={GROUP} />
      ) : activeTab === 1 ? (
        <BlogTab blogs={GROUP.blogs} activeChildTab={activeChildTab} />
      ) : activeTab === 2 ? (
        <MembersTab
          admins={GROUP.admins}
          allMembers={GROUP.allMembers}
          activeChildTab={activeChildTab}
        />
      ) : activeTab === 3 ? (
        <EventsTab activeChildTab={activeChildTab} events={GROUP.events} />
      ) : null}
      <InviteGroupModal group={GROUP} open={inviteModal} onClose={() => setInviteModal(false)} />
    </Box>
  );
};

export default GroupPage;
